import React from "react";

export const NotFound = () => {
  return (
    <div>
      <h1>Page Not Found</h1>
      <p>Page You are Looking for does not exist</p>
    </div>
  );
};
